import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="madero-page min-h-screen bg-cream font-sans text-brand-900 selection:bg-brand-500 selection:text-white" data-id="element-0" data-mp="3k89rlrzr0rhd">
      <MetaPixel data-id="element-1" data-mp="3f8ezjl48lvuq" />
      <Hero data-id="element-2" data-mp="2rkx33ca129lf" />
      <Features data-id="element-3" data-mp="2rknmugesbgsx" />
      <Pricing data-id="element-4" data-mp="2rk46h44s90h0" />
    </div>;
}